import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  DivBackgroundFullOpacity,
  DivBackgroundLowOpacity,
} from "@utils/extra-style";

const Price = (props) => {
  const { t, data } = props;
  return (
    <>
      {data.isActive == 0 && (
        <DivBackgroundLowOpacity>{data.price}</DivBackgroundLowOpacity>
      )}
      {data.isActive == 1 && (
        <DivBackgroundFullOpacity>{data.price}</DivBackgroundFullOpacity>
      )}
    </>
  );
};

Price.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Price);
